/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Space_Files_BlurbInputs */



/**
* | output |
* | --- |
* | "This is the file workspace for the space. Drag and drop to upload, organize files into folders, and embed them so the assistant can use them." |
*
* @param {Uno_Edu_Space_Files_BlurbInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_space_files_blurb = /** @type {((inputs?: Uno_Edu_Space_Files_BlurbInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Space_Files_BlurbInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dies ist der Datei-Arbeitsbereich des Space. Ziehen Sie Dateien zum Hochladen hierher, organisieren Sie sie in Ordnern und betten Sie sie ein, damit der Assistent sie nutzen kann.")
	return /** @type {LocalizedString} */ ("This is the file workspace for the space. Drag and drop to upload, organize files into folders, and embed them so the assistant can use them.")
});